// import React from "react";
import { useSubscription } from "@apollo/client";
import gql from "graphql-tag";
import { noop } from "../../../utils/noop";

export const OnSSOUserInvitedToAccount = () => {
  useSubscription(onSSOUserInvitedSubscription, {
    onSubscriptionData: ({ client: { cache }, subscriptionData }) => {
      const accountId =
        subscriptionData.data.onSSOUserInvitedToAccount.accountId;

      // Update users on that account
      try {
        const prev = cache.readQuery({
          query: getUsersOnAccountQuery,
          variables: {
            accountIds: [accountId],
          },
        });

        const newData = {
          ...prev,
          users: [
            {
              name:
                subscriptionData?.data?.onSSOUserInvitedToAccount?.name || "",
              email: subscriptionData.data.onSSOUserInvitedToAccount.email,
              id: subscriptionData.data.onSSOUserInvitedToAccount.id,
              status: subscriptionData.data.onSSOUserInvitedToAccount.status,
              roles: subscriptionData.data.onSSOUserInvitedToAccount.roles,
              __typename: "SSOUser",
            },
            ...prev.users,
          ],
        };

        cache.writeQuery({
          query: getUsersOnAccountQuery,
          data: newData,
          variables: { accountIds: [accountId] },
        });
      } catch {
        noop();
      }

      // Update the entire users list if loaded.

      try {
        const prev = cache.readQuery({ query: getAllUsersQuery });

        const userExists = prev.users.find(
          (x) => x.id === subscriptionData.data.id
        );

        let newData = { ...prev };

        if (userExists) {
          const updatedNewData = {
            ...prev,
            users: prev.users.map((usr) => {
              if (usr.id === subscriptionData.data.id) {
                return {
                  ...usr,
                  name:
                    subscriptionData?.data?.onSSOUserInvitedToAccount?.name ||
                    "",
                  email: subscriptionData.data.onSSOUserInvitedToAccount.email,
                  id: subscriptionData.data.onSSOUserInvitedToAccount.id,
                  status:
                    subscriptionData.data.onSSOUserInvitedToAccount.status,
                  roles: subscriptionData.data.onSSOUserInvitedToAccount.roles,
                  __typename: "SSOUser",
                };
              } else {
                return usr;
              }
            }),
          };

          newData = updatedNewData;
        } else {
          const newUsersList = {
            ...prev,
            users: [
              {
                name:
                  subscriptionData?.data?.onSSOUserInvitedToAccount?.name || "",
                email: subscriptionData.data.onSSOUserInvitedToAccount.email,
                id: subscriptionData.data.onSSOUserInvitedToAccount.id,
                status: subscriptionData.data.onSSOUserInvitedToAccount.status,
                roles: subscriptionData.data.onSSOUserInvitedToAccount.roles,
                __typename: "SSOUser",
              },
              ...prev.users,
            ],
          };

          newData = newUsersList;
        }

        cache.writeQuery({ query: getAllUsersQuery, data: newData });
      } catch (err) {
        console.error("All users not loaded, skipping...");
        console.error(err);
      }
    },
  });
  return null;
};

const onSSOUserInvitedSubscription = gql`
  subscription {
    onSSOUserInvitedToAccount {
      id
      email
      name
      status
      roles
      accountId
    }
  }
`;

const getUsersOnAccountQuery = gql`
  query users($accountIds: [String]) {
    users(accountIds: $accountIds) {
      id
      email
      name
      status
      roles
    }
  }
`;

const getAllUsersQuery = gql`
  query {
    users {
      id
      email
      name
      status
    }
  }
`;
